<template>
  <div class="root">
    <div class="relative flex flex-row items-center h-8 -mt-8" :class="[left]">
      <div :class="[background]" class="absolute top-4 diamond">&nbsp;</div>
    </div>
    <div :class="[background]" class="wrapper">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "BottomToolTipArrowRight",
  props: {
    background: {
      type: String,
      default: "bg-creme-50",
    },
    left: {
      type: String,
      default: "left-[30%]",
    },
  },
};
</script>
<style scoped>
.root {
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.15);
  @apply flex flex-col items-center justify-center rounded-16;
}
.diamond {
  transform: rotate(45deg);
  @apply w-8 h-8;
}
.wrapper {
  z-index: 100;
  @apply w-full p-6 space-y-6 rounded-16;
}
</style>
